import React, { useState, useContext, useRef, useEffect } from 'react';
import { TaskContext } from './Schedule/TaskContext';
import './FocusTimer.css';

const FocusTimer = () => {
    const { events, groups } = useContext(TaskContext);
    const [selectedEventId, setSelectedEventId] = useState('');
    const [timeLeft, setTimeLeft] = useState(0);
    const [savedTimes, setSavedTimes] = useState({});
    const [timerRunning, setTimerRunning] = useState(false);
    const [filterGroup, setFilterGroup] = useState('');
    const [showOnlyIncomplete, setShowOnlyIncomplete] = useState(true);
    const timerInterval = useRef(null);
    const [showTimeUpModal, setShowTimeUpModal] = useState(false);


    const selectTask = (event) => {
        const eventId = event.target.value;
        pauseTimer(); // Pause and save the current timer before switching tasks
        setSelectedEventId(eventId);
        const remainingTime = savedTimes[eventId] || getDefaultTime(eventId);
        setTimeLeft(remainingTime);
    };

    const getDefaultTime = (eventId) => {
        const selectedEvent = events.find(e => e.id === eventId);
        if (selectedEvent) {
            const start = new Date(selectedEvent.start.toDate());
            const end = new Date(selectedEvent.end.toDate());
            const duration = (end - start) / 60000; // Duration in minutes
            return duration * 60; // Convert minutes to seconds
        }
        return 0;
    };

    const handleTimeInputChange = (event) => {
        const newTime = event.target.value;
        setTimeLeft(newTime * 60); // Convert input minutes to seconds
        setSavedTimes(prev => ({ ...prev, [selectedEventId]: newTime * 60 }));
    };

    const startTimer = () => {
        if (!timerRunning && timeLeft > 0) {
            setTimerRunning(true);
            timerInterval.current = setInterval(() => {
                setTimeLeft(prevTime => {
                    if (prevTime <= 1) {
                        clearInterval(timerInterval.current);
                        setShowTimeUpModal(true); // Show the time's up modal when countdown reaches zero
                        return 0; // Make sure to stop at zero
                    }
                    return prevTime - 1;
                });
            }, 1000);
        }
    };



    const pauseTimer = () => {
        clearInterval(timerInterval.current);
        timerInterval.current = null;
        setTimerRunning(false);
        setSavedTimes(prev => ({ ...prev, [selectedEventId]: timeLeft }));
    };

    useEffect(() => {
        return () => clearInterval(timerInterval.current);
    }, []);

    const formatTime = (seconds) => {
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${mins}:${secs < 10 ? '0' : ''}${secs}`;
    };

    const filteredEvents = events.filter(event => {
        return (showOnlyIncomplete ? !event.completed : true) &&
            (filterGroup ? event.groupId === filterGroup : true);
    });

    return (
        <div className="focus-timer-container">
            <h3>Focus Timer</h3>
            <select className="focus-timer-dropdown" value={filterGroup} onChange={e => setFilterGroup(e.target.value)}>
                <option value="">All Groups</option>
                {groups.map(group => (
                    <option key={group.id} value={group.id}>{group.name}</option>
                ))}
            </select>
            <label>
                <input type="checkbox" checked={showOnlyIncomplete} onChange={() => setShowOnlyIncomplete(!showOnlyIncomplete)} />
                Show Only Incomplete Tasks
            </label>
            <select className="focus-timer-dropdown" value={selectedEventId} onChange={selectTask}>
                <option value="">Select a task to focus on</option>
                {filteredEvents.sort((a, b) => a.start.toDate() - b.start.toDate()).map(event => (
                    <option key={event.id} value={event.id}>
                        {`${event.title} - ${new Date(event.start.toDate()).toLocaleDateString()} ${new Date(event.start.toDate()).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true })} - ${new Date(event.end.toDate()).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true })}`}
                    </option>
                ))}
            </select>
            {selectedEventId && (
                <>
                    <div className="focus-timer-details">
                        <label htmlFor="timeInput">Time (minutes):</label>
                        <input
                            id="timeInput"
                            type="number"
                            value={Math.floor(timeLeft / 60)}
                            onChange={handleTimeInputChange}
                            disabled={timerRunning}
                        />
                    </div>
                    <div className="focus-timer-controls">
                        <button onClick={startTimer} disabled={timerRunning || !selectedEventId}>
                            Start
                        </button>
                        <button onClick={pauseTimer} disabled={!timerRunning}>
                            Pause
                        </button>
                    </div>
                </>
            )}
            {showTimeUpModal && (
                <div className="reminder-modal active">
                    <h3>Time's up!</h3>
                    <p>Your focus timer has finished. Well done, check it off your schedule</p>
                    <button onClick={() => setShowTimeUpModal(false)}>Close</button>
                </div>
            )}
        </div>
    );
};

export default FocusTimer;

